var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 14,
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  stroke: "#FFF",
  d: "M12.63 7.621c.28 0 .506-.231.506-.495v-.339a.5.5 0 0 0-.506-.495H7.865V1.526a.507.507 0 0 0-.495-.505h-.34a.5.5 0 0 0-.495.505v4.766H1.77a.507.507 0 0 0-.505.495v.34a.5.5 0 0 0 .505.494h4.766v4.766c0 .28.232.506.495.506h.34a.5.5 0 0 0 .495-.506V7.621h4.765z"
})));
export default __webpack_public_path__ + "teg/media/plus.b32d6872.svg";
export { SvgComponent as ReactComponent };